import { History } from 'history';
import i18next from 'i18next';
import { action, observable } from 'mobx';
import { Router } from 'src/core/router/Router';
import { configureMobX } from 'src/mobXSettings';
import { AuthStore } from 'src/stores/AuthStore/AuthStore';
import { BorrowerSettingsStore } from 'src/stores/BorrowerSettingsStore/BorrowerSettingsStore';
import { SettingsStore } from 'src/stores/SettingsStore/SettingsStore';
import { UserStore } from 'src/stores/UserStore/UserStore';

export class AppStoreClass {
    @observable started = false;

    @action
    async init() {
        configureMobX();
        await SettingsStore.load();

        if (SettingsStore.hasSettings) {
            await AuthStore.authenticate();
            await SettingsStore.setupInternationalization();
        }
        if (AuthStore.authenticated) {
            UserStore.loadUserInfo();
            UserStore.sendUTM();
            this.initLocale();
        }
    }

    @action
    async initLocale() {
        await BorrowerSettingsStore.loadSettings();
        if (
            BorrowerSettingsStore.settings.language &&
            BorrowerSettingsStore.settings.language !== i18next.language
        ) {
            i18next.changeLanguage(BorrowerSettingsStore.settings.language);
        }
    }

    setHistory(history: History) {
        Router.setHistory(history);
        this.started = true;
    }
}

export const AppStore = new AppStoreClass();
